import React, { useEffect, useState } from 'react';
import { X, Keyboard } from 'lucide-react';

const SHORTCUTS = [
  { keys: ['/'], description: 'Søk / fokuser søkefelt' },
  { keys: ['Escape'], description: 'Lukk / fjern søk' },
  { keys: ['↑', '↓'], description: 'Naviger mellom samtaler' },
  { keys: ['Enter'], description: 'Åpne valgt samtale' },
  { keys: ['s'], description: 'Stjer / fjern stjer valgt samtale' },
  { keys: ['?'], description: 'Vis / skjul denne hjelpen' },
];

export default function KeyboardShortcutsModal() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleKey = (e) => {
      // Don't trigger shortcuts when typing in input fields
      const tag = e.target?.tagName?.toLowerCase();
      if (tag === 'input' || tag === 'textarea' || e.target?.contentEditable === 'true') return;

      if (e.key === '?') {
        e.preventDefault();
        setOpen(prev => !prev);
      }
      if (e.key === 'Escape' && open) {
        setOpen(false);
      }
    };

    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [open]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm"
      onClick={(e) => { if (e.target === e.currentTarget) setOpen(false); }}
      data-testid="keyboard-shortcuts-modal"
    >
      <div className="bg-navy-800 border border-navy-600 rounded-xl shadow-2xl w-full max-w-md mx-4">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-navy-600">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-lg bg-accent-blue/20 flex items-center justify-center">
              <Keyboard size={16} className="text-accent-blue" />
            </div>
            <h2 className="font-heading text-base font-semibold text-white">Tastatursnarveier</h2>
          </div>
          <button
            onClick={() => setOpen(false)}
            className="p-1.5 text-slate-400 hover:text-white rounded-lg hover:bg-navy-700 transition-colors"
            aria-label="Lukk"
          >
            <X size={16} />
          </button>
        </div>

        {/* Shortcuts list */}
        <div className="p-6 space-y-3">
          {SHORTCUTS.map(({ keys, description }) => (
            <div key={description} className="flex items-center justify-between gap-4">
              <span className="text-sm text-slate-300">{description}</span>
              <div className="flex items-center gap-1 flex-shrink-0">
                {keys.map((k) => (
                  <kbd
                    key={k}
                    className="inline-flex items-center justify-center min-w-[2rem] px-2 py-1 bg-navy-700 border border-navy-500 rounded text-xs font-mono text-slate-300 shadow-sm"
                  >
                    {k}
                  </kbd>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="px-6 pb-4 text-xs text-slate-600 text-center">
          Trykk <kbd className="inline-flex items-center px-1.5 py-0.5 bg-navy-700 border border-navy-500 rounded text-xs font-mono text-slate-400">?</kbd> for å åpne/lukke
        </div>
      </div>
    </div>
  );
}
